import styled from "styled-components";
import Theme from "../../../../Styles/Themes";
import config from "../../../../Config/config.json"
import { motion } from "framer-motion";

import SVG from "react-inlinesvg";

export const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    flex-direction: column;
    border-radius: 10px;
    transition: 1s;
    padding: 15px 24px;
    background: ${(props) => ( props.$select ? '#014642' : 'transparent')};
    width: 80%;
    filter: ${(props) => (props.$active ? 'grayscale(0)' : 'grayscale(100)')};
    position: relative;
     &:hover {
        background: ${(props) => ( props.$select ? '#014642' : props.$function ? '#3E78AA' : 'transparent')};
    }
`;

export const ContainerIcon = styled.a`
    display: flex;
    flex-direction: ${(props) => ( props.$select ? 'row' : 'column')};
    justify-content: ${props => props.$aling};
    align-items: ${props => props.$visibility ?  'flex-start' : 'center'};
    width: 100%;
    box-sizing: border-box;
    border-radius: 10px;
    border: none;
    cursor: ${props => props.$function ? 'pointer': 'auto'};
    outline: none;
    color: ${props => props.$function ? '#F2F2F2': '#A3A3A3'};
    font-weight: 600;
    font-size: ${Theme[config.theme].font.labels['small'].size};
    line-height: ${Theme[config.theme].font.labels['small'].line_height};
    transition: 0.8s;
    gap: 15px;
    text-decoration: none;
    overflow: hidden;
    @media (min-width: 1281px) {
        font-size: ${Theme[config.theme].font.labels[config.fontSize].size};
        line-height: ${Theme[config.theme].font.labels[config.fontSize].line_height};
    }
`;

export const ContainerItem = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: ${props => props.$aling};
    align-items: center;
    gap: 15px;
`;

export const SideBarIcon = styled(SVG)`
    width: 30px;
    height: 30px;
    align-self: center;
    & path {
        fill: ${({ fill }) => fill};
    }
    @media (min-width: 1281px) {
        width: 30px;
        height: 30px;
    }
`;

export const SubItensContainer = styled(motion.div)`
    display: flex;
    justify-content: center;
    align-items: center;
    padding-left: ${props => props.$isSelected ? '10px': '35px'};
`;

export const TextItem = styled.p`
    display: flex;
    justify-content: ${props => props.$aling};
    align-items: center;
    width: 100%;
    border-radius: 10px;
    border: none;
    cursor: ${props => props.$function ? 'pointer': 'auto'};
    outline: none;
    color: ${props => props.$function ? '#F2F2F2': '#A3A3A3'};
    font-weight: 600;
    font-size: ${Theme[config.theme].font.labels['small'].size};
    line-height: ${Theme[config.theme].font.labels['small'].line_height};
    transition: 0.8s;
    gap: 15px;
    text-decoration: none; 
    @media (min-width: 1281px) {
        font-size: ${Theme[config.theme].font.labels[config.fontSize].size};
        line-height: ${Theme[config.theme].font.labels[config.fontSize].line_height};
    }
`;

export const ContainerSvg = styled.div`
    width: 30px;
    height: 30px;
    @media (min-width: 1281px){
        width: 30px;
        height: 30px;
    }
`;